 "use strict";
 /**
  * trsHight Module
  *
  * Description
  */
 angular.module('trsloginHeightModule', []).directive('trsloginHeight', ['$window', '$parse', '$timeout', function($window, $parse, $timeout) {

     return {
         restrict: 'EA',
         link: function(scope, iElement, iAttrs) {
             function contentHeigth() {
                 $(".edit_table").height($(window).height() - 272 );
             }
             $timeout(function() {
                 contentHeigth();
             });
             $(".view_body,body").resize(function(event) {
                 contentHeigth();
             });
             $(window).resize(function(event) {
                 contentHeigth();
             });
         }
     };
 }]);